var url_path = window.location.pathname;

if (url_path == '/products' || url_path == '/products/'){
  window.location.href = "/collections/all";
}

function addToCartEventFB(){
  if (typeof fbq === 'function') fbq('track', 'AddToCart');
}

$(window).on('load', function() {

    // -------- Klavyio form submit + FB lead
    window.addEventListener("klaviyoForms", function(e) {
        if (e.detail.type == 'submit' && typeof fbq === 'function') {
            fbq('track', 'Lead');
        }
    });


    /* ---- prefix PageFly links with the active Shopify locale ---- */
    var localeMatch = window.location.pathname.match(/^\/([a-z]{2}(?:-[a-z]{2})?)(?=\/|$)/);
    if (localeMatch) {
        var locale = localeMatch[1];

        // add/remove segments here as needed
        var segments = ['products', 'pages', 'collections'];
        var segRe = segments.join('|');

        $('a[href*="/"]').filter(function () {
            return new RegExp('/(' + segRe + ')/').test($(this).attr('href') || '');

        }).each(function () {
            var href = $(this).attr('href');
            // skip if already localized

            if (new RegExp('^(https?:\\/\\/[^\\/]+)?\\/' + locale + '\\/').test(href)) return;

            $(this).attr('href', href.replace(
                new RegExp('(^(?:https?:\\/\\/[^\\/]+)?)\\/(' + segRe + ')\\/'),
                '$1/' + locale + '/$2/'
            ));
        });
    }



});


/* ---- Brand mark: render every "OrthoFlexx" / "OrthoFlexx®" in page text as OrthoFlexx<sup class="of-reg">®</sup> (2026-09-22) ----
   Runs on the body text only. Skips scripts, styles, form fields, editable areas, mailto links and text that
   already has a <sup>. Lowercase "orthoflexx" (emails, URLs) is left alone. Styling lives in custom.css (sup.of-reg).
   2026-09-24: also skips quoted text written by other people: customer reviews and the podiatrist endorsement
   (see NO_REG_SELECTOR and NO_REG_CLASS). Add data-no-reg to any element to keep its text untouched.
   2026-09-28: a page can opt out completely: if any element on it has data-no-reg-page, nothing is changed
   (used by third-person advertorials, e.g. sections/of-compare-article.liquid). */
(function () {
  var RE = /Ortho[Ff]lexx(?:\s?[®])?/g;
  var SKIP = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, INPUT: 1, SELECT: 1, OPTION: 1, SUP: 1, SVG: 1, TITLE: 1, CODE: 1, PRE: 1, BLOCKQUOTE: 1, Q: 1 };

  /* review cards and the doctor's quote: text other people wrote is left as they wrote it */
  var NO_REG_SELECTOR = [
    '[data-no-reg]',
    '.cw-rev__card',            // reviews carousel (cw-pdp-reviews)
    '.cw-pdp-rv-card',          // review card under the product images
    '.cw-endorsement-section',  // podiatrist endorsement (cw-pdp-author)
    '.kl6-reviews-box',         // reviews slider in the empty cart
    '.qz__quote',               // review under the quiz
    '.cw-tmt-review-sec',       // older testimonials section
    '.cw-support-reviews'       // review rows in the pain / steps sections
  ].join(',');
  /* catches review and testimonial blocks in other sections by their class names */
  var NO_REG_CLASS = /(^|[\s_-])(review|reviews|testimonial|testimonials|endorsement|quote)([\s_-]|$)/i;

  /* whole page opted out (see the 2026-09-28 note above) */
  function pageOptedOut() {
    return !!document.querySelector('[data-no-reg-page]');
  }

  function skip(el) {
    for (var e = el; e && e !== document.body; e = e.parentElement) {
      if (SKIP[e.tagName]) return true;
      if (e.isContentEditable) return true;
      if (e.tagName === 'A' && /^mailto:/i.test(e.getAttribute('href') || '')) return true;
      if (e.matches && e.matches(NO_REG_SELECTOR)) return true;
      if (typeof e.className === 'string' && NO_REG_CLASS.test(e.className)) return true;
    }
    return false;
  }

  function fix(root) {
    if (!root || pageOptedOut()) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
    var nodes = [], n;
    while ((n = walker.nextNode())) {
      if (n.nodeValue.indexOf('rtho') !== -1 && RE.test(n.nodeValue)) nodes.push(n);
      RE.lastIndex = 0;
    }
    nodes.forEach(function (node) {
      if (!node.parentNode || skip(node.parentElement)) return;
      var text = node.nodeValue;
      /* text already followed by a <sup>®</sup> written in the source: leave that occurrence as is */
      var next = node.nextSibling;
      var endsBrand = /Ortho[Ff]lexx\s?$/.test(text);
      if (endsBrand && next && next.nodeType === 1 && next.tagName === 'SUP') return;

      var frag = document.createDocumentFragment();
      var last = 0, m;
      RE.lastIndex = 0;
      while ((m = RE.exec(text))) {
        if (m.index > last) frag.appendChild(document.createTextNode(text.slice(last, m.index)));
        frag.appendChild(document.createTextNode('OrthoFlexx'));
        var sup = document.createElement('sup');
        sup.className = 'of-reg';
        sup.textContent = '®';
        frag.appendChild(sup);
        last = m.index + m[0].length;
      }
      if (last < text.length) frag.appendChild(document.createTextNode(text.slice(last)));
      node.parentNode.replaceChild(frag, node);
    });
  }

  function run() { fix(document.body); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();

  /* content the theme editor or cart drawer re-renders later */
  document.addEventListener('shopify:section:load', function (e) { fix(e.target); });
})();